import { Controller } from "@hotwired/stimulus"

export default class CountdownController extends Controller {
  static targets = ["output"]
  static values = {
    startTime: String,
    endTime: String
  }

  connect() {
    this.startTime = new Date(this.startTimeValue)
    this.endTime = new Date(this.endTimeValue)
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    const now = new Date()
    if (now < this.startTime) {
      this.outputTarget.textContent = "Countdown not started"
      return
    }
    if (now >= this.endTime) {
      this.outputTarget.textContent = "Countdown ended"
      return
    }

    const diff = this.endTime - now
    const seconds = Math.floor(diff / 1000) % 60
    const minutes = Math.floor(diff / 1000 / 60) % 60
    const hours = Math.floor(diff / 1000 / 60 / 60) % 24
    const days = Math.floor(diff / 1000 / 60 / 60 / 24)

    this.outputTarget.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`
  }
}
